import { LOCATION_CHANGE } from 'connected-react-router'
import {
	STOP_SCANNING, RESET_ASSISTANT,
	START_SCANNING,
	LocaleTypes,
	SET_LOCALE,
	CALL_ASSISTANT,
	CALL_ASSISTANT_FULFILLED,
	CALL_ASSISTANT_REJECTED,
	ActionTypes,
	SEARCH_BARCODE_FULFILLED,
} from '../types'

interface UiState {
	assistantRequested: boolean
	assistantCalled: boolean
	locale: LocaleTypes
	scanPopupOpen: boolean
	fetchingBarcodeResult: boolean
	showPromotionalPage: boolean
}

const initialState: UiState = {
	assistantRequested: false,
	assistantCalled: false,
	locale: 'en',
	scanPopupOpen: false,
	fetchingBarcodeResult: false,
	showPromotionalPage: false,
}

export default function reducer(state = initialState, action: ActionTypes): UiState {
	switch (action.type) {
		case CALL_ASSISTANT:
			return {
				...state,
				assistantRequested: true,
				assistantCalled: false,
			}

		case CALL_ASSISTANT_FULFILLED:
			return {
				...state,
				assistantRequested: false,
				assistantCalled: true,
			}

		case RESET_ASSISTANT:
			return {
				...state,
				assistantRequested: false,
				assistantCalled: false,
			}

		case CALL_ASSISTANT_REJECTED:
			return {
				...state,
				assistantRequested: false,
			}

		case SET_LOCALE:
			return {
				...state,
				locale: action.payload.locale,
			}

		case START_SCANNING:
			return {
				...state,
				scanPopupOpen: true,
			}

		case STOP_SCANNING:
			return {
				...state,
				scanPopupOpen: false,
			}

		case SEARCH_BARCODE_FULFILLED:
			return {
				...state,
				showPromotionalPage: action.payload.product?.type_id === '14',
			}

		case LOCATION_CHANGE:
			return {
				...state,
				showPromotionalPage: false,
			}

		default:
			return state
	}
}
